import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {checkinpoint, checkinpoints, checkinpointEnable, checkinpointDisable,subAccountCheckinpoints,
    subUserCheckinpoints,assignSubUserCheckinpoints,checkinpointCover,subUserAllCheckinpoints,
    subUserAllCheckinpoint,ticketCheckinpoints,ticketCheckinpoint,checkinCancel} = api



/**
 * 查找签到点
 */
export async function findCheckinpoint(params) {
    return request({url: checkinpoint, method: 'get', data: params,})
}

/**
 * 创建签到点
 */
export async function createCheckinpoint(params) {
    return request({url: checkinpoints, method: 'post', data: params,})
}

/**
 * 更新签到点
 */
export async function updateCheckinpoint(params) {
    return request({url: checkinpoint, method: 'put', data: params,})
}
/**
 * 更新签到点
 */
export async function updateCheckinpointCover(params) {
    return request({url: checkinpointCover, method: 'put', data: params,})
}
export async function patchCheckinpoints(params) {
    return request({url: checkinpoints, method: 'patch', data: params,})
}

/**
 * 打开签到点
 */
export async function enableCheckinpoint(params) {
    return request({url: checkinpointEnable, method: 'post', data: params,})
}


/**
 * 关闭签到点
 */
export async function disableCheckinpoint(params) {
    return request({url: checkinpointDisable, method: 'post', data: params,})
}


/**
 * 删除签到点
 */
export async function deleteCheckinpoint(params) {
    return request({url: checkinpoint, method: 'delete', data: params,})
}
export async function findCheckinCancel(params) {
    return request({url: checkinCancel, method: 'post', data: params,})
}


/**
 * 查找签到点列表
 */
export async function findCheckinpoints(params) {
    return request({url: checkinpoints, method: 'get', data: params,})
}

/**
 * 删除签到点
 */
export async function deleteCheckinpoints(params) {
    return request({url: checkinpoint, method: 'delete', data: params,})
}

/**
 * 子账号签到点
 */
export async function findSubAccountCheckinpoints(params) {
    return request({url: subAccountCheckinpoints, method: 'get', data: params,})
}
/**
 * 查询签到点子账号
 */
export async function findSubUserCheckinpoints(params) {
    return request({url: subUserCheckinpoints, method: 'get', data: params,})
}
/**
 * 查询签到点子账号
 */
export async function createAssignSubUserCheckinpoints(params) {
    return request({url: assignSubUserCheckinpoints, method: 'put', data: params,})
}
/**
 * 查询签到点子账号
 */
export async function findSubUserAllCheckinpoints(params) {
    return request({url: subUserAllCheckinpoints, method: 'get', data: params,})
}
export async function deleteSubUserAllCheckinpoint(params) {
    return request({url: subUserAllCheckinpoint, method: 'delete', data: params,})
}
/**
 * 查询签到点票务
 */
export async function findTicketCheckinpoint(params) {
    return request({url: ticketCheckinpoint, method: 'get', data: params,})
}
export async function updateTicketCheckinpoints(params) {
    return request({url: ticketCheckinpoints+'?checkinpointId='+params.checkinpointId, method: 'patch', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/checkinpoint.js